export default "/static/media/icon-slider-right.168f8d42.svg";